let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("esTEG")).then(() => parcelRequire('2QzjW'));